var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBack)?_c('div',{staticClass:"goback",on:{"click":_vm.goback}},[_c('img',{staticClass:"location",attrs:{"src":require("@/assets/images/site/arrow_small.png"),"alt":""}}),_vm._v("\n    返回\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }